import React, { useState } from 'react';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import '../../i18n'
import { TextField, Button, Link, Grid, Container, Box, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { AlertBar } from '../Utils/Utils';
import { loginUser, acceptUser } from '../../Api/AuthApi'
import ToS from './ToS';


export default function LoginForm({ onLogin }) {

    const [data, setData] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const [showTosModal, setShowTosModal] = useState(false);
    const [pendingUserData, setPendingUserData] = useState(null);

    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ severity: 'info', message: '' });
    const navigate = useNavigate();

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const formik = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true);

            try {
                const data = await loginUser(values.email, values.password);
                console.log('Login response:', data);
                setData(values.email)

                if (data["tos_accept"] === true) {
                    onLogin();
                    setAlertInfo({ severity: 'success', message: t('loginSuccess') });
                    setOpen(true);
                    navigate('/map');
                } else {
                    setPendingUserData(data);
                    setShowTosModal(true);
                }

            } catch (error) {
                console.error('Login error:', error.message);
                setAlertInfo({ severity: 'error', message: error.message || t('loginFailed') });
                setOpen(true);
            }

            setSubmitting(false);
        },
    });

    const handleClose = () => {
        setOpen(false);
    };

    const handleAcceptTos = async () => {
        const msg = await acceptUser(data);
        if (msg.status === 200) {
            setShowTosModal(false);
            if (pendingUserData) {
                onLogin();
                setAlertInfo({ severity: 'success', message: t('loginSuccess') });
                setOpen(true);
                navigate('/map');
            }
        }
    };


    return (
        <>
            <Container maxWidth="sm">
                <Box
                    sx={{
                        marginTop: 12,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                    <img
                        src="/logo.svg"
                        alt="Logo"
                        width={"100%"}
                        height={"50%"}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <form onSubmit={formik.handleSubmit}>
                        <TextField
                            fullWidth
                            margin="normal"
                            id="email"
                            name="email"
                            label={t('email')}
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            id="password"
                            name="password"
                            label={t('password')}
                            type={showPassword ? 'text' : 'password'}
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton 
                                            aria-label="toggle password visibility"
                                            onClick={handleClickShowPassword}
                                            edge="end"
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <Button
                            color="primary"
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}>
                            {t('login')}
                        </Button>
                        <AlertBar open={open} handleClose={handleClose} message={alertInfo.message} severity={alertInfo.severity} >

                        </AlertBar>
                        <Grid container justifyContent={'right'}>
                            <Grid item xs>
                                <Link href="/forgot-password" variant="body2">
                                    {t('forgotpass')}
                                </Link>
                            </Grid>
                            <Grid item>
                                {/* <Link href="/registration" variant="body2">
                                {t('registration')}
                            </Link> */}
                            </Grid>
                        </Grid>


                    </form>
                </Box>
            </Container>
            {showTosModal && (
                <Dialog open={showTosModal} onClose={() => setShowTosModal(false)}>
                    <DialogTitle textAlign={'center'}>СОГЛАШЕНИЕ О
                        КОНФИДЕНЦИАЛЬНОСТИ</DialogTitle>
                    <DialogContent>
                        <DialogContentText><ToS></ToS></DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleAcceptTos} autoFocus>Согласен</Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    )
}
